import map from 'lodash/map';
import React from 'react';
import text from '../../../text';
import { statuses } from '../../orderListing/consts';
import CreateTable from '../../select/CreateTable';
var inprogress = statuses.inprogress, pending = statuses.pending, completed = statuses.completed, cancelled = statuses.cancelled;
var getStatusOption = function(status) {
    return status ? {
        status: status,
        label: status
    } : undefined;
};
var OPTIONS = map([
    inprogress,
    pending,
    completed,
    cancelled
], function(status) {
    return {
        status: status.name,
        label: status.name
    };
});
var StatusSelect = function(props) {
    var onChange = props.onChange, status = props.status, placeholder = props.placeholder;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CreateTable, {
        options: OPTIONS,
        onChange: function(option) {
            var value = option.status ? option : getStatusOption(option.value);
            onChange(value);
        },
        placeholder: placeholder,
        createInputPlaceholder: text('enterCustomStatus'),
        getOptionValue: function(o) {
            return o.status;
        },
        value: getStatusOption(status)
    }));
};
export default StatusSelect;
